export default __webpack_public_path__ + "static/media/small_diamonds.3c7cfd37.png";